import { colors } from '@material-ui/core';

const MuiAppBar = {
  root: {
    backgroundColor: colors.grey[50],
    colorPrimary: colors.grey[50],
  }
};

export default MuiAppBar;